// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"175":"963d3151","270":"37c4fa11","599":"f99b1969","823":"dde11b0d"}[chunkId] + ".css";
};